const NO_BREAK_SPACE = /&nbsp;/g;

/**
 * The editor's HTML as the support email gets it. The answer goes as it is into a <span> of core's 600px email table.
 * Quill 2 (react-quill-new) gives its semantic HTML, with bullet lists as <ul> as Quill 1 gave them, but writes every
 * space as &nbsp;, so a paragraph no longer wraps and widens the email; the spaces are plain again, as with Quill 1.
 */
const emailHtmlOf = (html: string): string => html.replace(NO_BREAK_SPACE, ' ');

const HTML_TAG = /<[^>]*>/g;

/** Whether the editor's HTML has any text; an empty editor gives <p><br></p>, spaces only give &nbsp;. */
export const hasText = (html: string | undefined): boolean => {
  if (!html) return false;
  return html.replace(HTML_TAG, '').replace(NO_BREAK_SPACE, ' ').trim().length > 0;
};

export default emailHtmlOf;
